import CircleEmptyPlusIcon from "../images/CircleEmptyPlusIcon.mjs";

/**
 * App "add" action
 * @see {GlyphIcon}
 * @see {CircleEmptyPlusIcon}
 */
const AppAddIcon = class extends CircleEmptyPlusIcon {}

export default AppAddIcon;